export default __webpack_public_path__ + "static/media/rtcomputingpl.fe0db492.png";